import { Injectable, Type, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import type { EngineDialogFormComponent } from '@core/engine-forms/components/engine-dialog-form/engine-dialog-form.component';
import { EngineTranslationService, TranslationType } from '@core/engine-translations/services/translation.service';
import { RecordsSelectorViewConfig } from '@core/engine-views/components/records-selector-view/records-selector-view-config';
import { AlertDialogComponent } from '@shared/alert-dialog/alert-dialog.component';
import { Observable } from 'rxjs';
import { UploadDialogComponent } from 'src/core/blob/upload-dialog/upload-dialog.component';
import {
  IDialogConfig,
  IDialogFormConfig,
  IRecordSelectorConfig,
  IToolsService,
  IUploadDialogConfig,
} from 'src/engine-sdk';
import { IEngineODataState } from 'src/engine-sdk/contract/odata/iodata-state.model';
import { RecordsSelectorViewComponent } from '../engine-views/components/records-selector-view/records-selector-view.component';

@Injectable({
  providedIn: 'root',
})
export class ToolsService implements IToolsService {
  private _dialog = inject(MatDialog);
  private _translationService = inject(EngineTranslationService);
  private _engineDialogFormComponent?: Type<EngineDialogFormComponent>;

  constructor() {}

  openRecordSelector(config: IRecordSelectorConfig) {
    const { disableClose: disableClose, filters, ...data } = config;
    const query = filters?.filters?.length > 0 ? ({ filter: filters } as IEngineODataState) : null;
    this._dialog.open(RecordsSelectorViewComponent, {
      panelClass: 'app-expander-dialog',
      data: { ...data, query } as RecordsSelectorViewConfig,
      disableClose: disableClose,
      autoFocus: false,
      restoreFocus: false,
    });
  }

  openDialog(config: IDialogConfig) {
    const { disableClose: disableClose, ...data } = config;
    this._dialog.open(AlertDialogComponent, {
      panelClass: 'app-common-dialog',
      data: data,
      disableClose: disableClose,
      autoFocus: false,
      restoreFocus: false,
    });
  }

  openUploadFileDialog(config: IUploadDialogConfig) {
    this._dialog.open(UploadDialogComponent, {
      panelClass: 'app-common-dialog',
      data: config,
      autoFocus: false,
      restoreFocus: false,
    });
  }

  async openFormDialog(options?: IDialogFormConfig) {
    if (!this._engineDialogFormComponent) {
      const m = await import('@core/engine-forms/components/engine-dialog-form/engine-dialog-form.component');
      this._engineDialogFormComponent = m.EngineDialogFormComponent;
    }
    this._dialog.open(this._engineDialogFormComponent, {
      panelClass: ['app-common-dialog', 'app-form-dialog'],
      width: 'min(760px, 90vw)',
      data: options,
      autoFocus: false,
      restoreFocus: false,
    });
  }

  translate(message: string, context?: Object, type: TranslationType = TranslationType.Business): Observable<string> {
    return this._translationService.translate(message, context, type);
  }
}
